import { StyleSheet, ViewProps } from 'react-native'
import { useRef } from 'react'
import { Draft, ProfileDataEmail } from 'zens-store'
import { observer } from 'mobx-react-lite'
import { Trans, useTranslation } from 'react-i18next'
import { object, string } from 'yup'
import { Spacing, Text } from 'zens-storybook'

import { Form } from '../form'
import { NavigationConfirm } from '../navigation'

const styles = StyleSheet.create({
  container: {
    flex: 1,
  },
  email: {
    marginTop: Spacing.XS,
  },
})

interface Props extends ViewProps {
  data: ProfileDataEmail
  onSave?: (draft: Draft<ProfileDataEmail>) => Promise<void>
  onCancel?: (draft: Draft<ProfileDataEmail>) => Promise<void>
  errors?: Record<keyof ProfileDataEmail, string>
}

const ProfileEmail = (props: Props) => {
  const { data, onSave, onCancel, style, ...otherProps } = props
  const { t } = useTranslation()
  const draft = useRef(new Draft(data)).current

  const { email } = draft.data

  const renderEmail = () => (
    <Text style={styles.email}>
      <Trans>
        {/* @ts-expect-error Typing of vars in trans not working correctly  */}
        Your email address is <Text level={5}>{{ email }}</Text>
      </Trans>
    </Text>
  )

  const config = {
    groups: [
      {
        fields: [
          {
            key: 'email',
            label: t('Email address'),
            FieldInputComponent: renderEmail,
          },
          {
            key: 'new_email',
            label: t('New email address'),
            fieldProps: {
              autoCapitalize: 'none',
              autoComplete: 'email',
              inputMode: 'email',
            },
          },
          {
            key: 'password',
            label: t('Password'),
            fieldProps: {
              autoCapitalize: 'none',
              autoComplete: 'password',
              secureTextEntry: true,
            },
          },
        ],
      },
    ],
  }

  const schema = object({
    new_email: string().required(t('Email address is required')).email(t('Invalid email address')),
    password: string().required(t('A password is required')),
  })
  return (
    <>
      <Form
        style={[styles.container, style]}
        draft={draft}
        config={config}
        schema={schema}
        buttons={[
          [
            {
              title: t('Save'),
              onPress: onSave,
              validate: true,
            },
            {
              title: t('Cancel'),
              onPress: onCancel,
              light: true,
            },
          ],
        ]}
        {...otherProps}
      />
      <NavigationConfirm draft={draft} />
    </>
  )
}

export default observer(ProfileEmail)
